/**
 *      ev01_tipologia.js
 *          Script de ev01_tipologia.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */

/* ======================================================================================================== */
import moment from 'moment'
import ingreso from './ingreso.vue'

import Vue from 'vue';
import jsPDF from 'jspdf'
Vue.use(jsPDF)

import { store } from './../store/store'

// import 'materialize-css/dist/css/materialize.min.css'
import M from 'materialize-css'

export default {
     name: 'tipologia',
     components: {
          'moment': moment,
          'input-date': ingreso,
     },
     template: `#formaTipologia`,     
     data() {
          return {
               temporal: 0,
               ejemplo: {},
               eval_tipolo: {}, res: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               //? .....................................................................................................................................................................................................................
               activott1:"active", activott2: '!active', activott3: "!active",  
               vertt1: true, vertt2: false, vertt3: false,  
               area1: "", area2: '', area3: '',

               //? .....................................................................................................................................................................................................................

          } // return
     }, // data()
     mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = M.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = M.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = M.Tabs.init(elem, {});

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },
     computed: {
          l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder() {
               return this.ejeSinContestar();
          },
     },
     methods: {
          crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_tipolo.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "TipoPer_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación TIPO DE PERSONALIDAD para " + this.eval_tipolo.nombre + " de " + this.eval_tipolo.empresa+ " ( "+this.eval_tipolo.depto+" )");

               this.respuestas(doc);
               this.losresultados(doc);
               this.latopologia(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          latopologia(doc) {

               this.res.par1iguales = false; this.res.par2iguales = false; this.res.par3iguales = false; this.res.par4iguales = false;
               this.res.topologiaEI1 = ""; this.res.topologiaSN1 = ""; this.res.topologiaTF1 = ""; this.res.topologiaJP1 = "";

               console.log("** resultados");
               console.log("E ? ", this.res.E, "; I ? ", this.res.I, "; par1iguales ? ", this.res.par1iguales, "; topologiaEI ? ", this.res.topologiaEI1);
               /* E > I, I > E, I = E */
               if (this.res.E > this.res.I) { this.res.topologiaEI1 = "E -" }
               else
                    if (this.res.I > this.res.E) { this.res.topologiaEI1 = "I -" }
                    else {
                         this.res.par1iguales = true;
                         this.res.topologiaEI1 = "E -";
                    }
               console.log("E ? ", this.res.E, "; I ? ", this.res.I, "; par1iguales ? ", this.res.par1iguales, "; topologiaEI ? ", this.res.topologiaEI1);
               console.log("-------------------------------------------------------");

               /* S > N, N > S, S = N */
               console.log("S ? ", this.res.S, "; N ? ", this.res.N, "; par2iguales ? ", this.res.par2iguales, "; topologiaSN ? ", this.res.topologiaSN1);
               if (this.res.S > this.res.N) { this.res.topologiaSN1 = "S -" }
               else
                    if (this.res.N > this.res.S) { this.res.topologiaSN1 = "N -" }
                    else {
                         this.res.par2iguales = true;
                         this.res.topologiaSN1 = "S -";
                    }
               console.log("S ? ", this.res.S, "; N ? ", this.res.N, "; par2iguales ? ", this.res.par2iguales, "; topologiaSN ? ", this.res.topologiaSN1);
               console.log("-------------------------------------------------------");

               /* T > F, F > T, T = F */
               console.log("T ? ", this.res.T, "; F ? ", this.res.F, "; par3iguales ? ", this.res.par3iguales, "; topologiaTF ? ", this.res.topologiaTF1);
               if (this.res.T > this.res.F) { this.res.topologiaTF1 = "T -" }
               else
                    if (this.res.F > this.res.T) { this.res.topologiaTF1 = "F -" }
                    else {
                         this.res.par3iguales = true;
                         this.res.topologiaTF1 = "T -";
                    }
               console.log("T ? ", this.res.T, "; F ? ", this.res.F, "; par3iguales ? ", this.res.par3iguales, "; topologiaTF ? ", this.res.topologiaTF1);
               console.log("-------------------------------------------------------");


               /* J > P, P > J, J = P */
               console.log("J ? ", this.res.J, "; P ? ", this.res.P, "; par4iguales ? ", this.res.par4iguales, "; topologiaJP ? ", this.res.topologiaJP1);
               if (this.res.J > this.res.P) { this.res.topologiaJP1 = "J -" }
               else
                    if (this.res.P > this.res.J) { this.res.topologiaJP1 = "P -" }
                    else {
                         this.res.par4iguales = true;
                         this.res.topologiaJP1 = "J -";
                    }
               console.log("J ? ", this.res.J, "; P ? ", this.res.P, "; par4iguales ? ", this.res.par4iguales, "; topologiaJP ? ", this.res.topologiaJP1);
               console.log("-------------------------------------------------------");

               this.res.topologia1 = ""; this.res.topologia2 = ""; this.res.topologia3 = ""; this.res.topologia4 = ""; this.res.topologia5 = "";
               this.res.topologia6 = ""; this.res.topologia7 = ""; this.res.topologia8 = ""; this.res.topologia9 = ""; this.res.topologia10 = "";
               this.res.topologia11 = ""; this.res.topologia12 = ""; this.res.topologia13 = ""; this.res.topologia14 = ""; this.res.topologia15 = "";
               this.res.topologia16 = "";

               /* Evalua cómo están los pares */
               /* Caso 1: Todos los pares diferentes */
               if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === false) {

                    this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + this.res.topologiaTF1 + this.res.topologiaJP1;

                    this.res.topologia = "CASO ESPERADO: todos los pares tienen valores diferentes.";
               } else {
                    /* Acá tengo los 15 casos restantes */
                    /* ================================ */

                    /* Caso 2: que el primer par (E,I) sea igual */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === false) {

                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + this.res.topologiaTF1 + this.res.topologiaJP1;
                    }
                    /* Caso 3: que el primero y segundo par (E,I) & (S,N) sean iguales */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === false) {

                         this.res.topologia1 = 'E -' + 'S -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + 'S -' + this.res.topologiaTF1 + this.res.topologiaJP1;

                         this.res.topologia3 = 'E -' + 'N -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia4 = 'I -' + 'N -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                    }
                    /* Caso 4: que el primero y tercer par (E,I) && (T,F) sean iguales */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === false) {

                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + 'T -' + this.res.topologiaJP1;

                         this.res.topologia3 = 'E -' + this.res.topologiaSN1 + 'F -' + this.res.topologiaJP1;
                         this.res.topologia4 = 'I -' + this.res.topologiaSN1 + 'F -' + this.res.topologiaJP1;
                    }
                    /* Caso 5: que el primero y cuarto par (E,I) && (J,P) sean iguales */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'J';

                         this.res.topologia3 = 'E -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'P';
                         this.res.topologia4 = 'I -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'P';
                    }
                    /* Caso 6: que solo el SEGUNDO (S,N) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === false) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                    }
                    /* Caso 7: que el segundo (S,N) y el tercero (T,F) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === true && this.res.par3iguales === true && this.res.par4iguales === false) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + 'T -' + this.res.topologiaJP1;

                         this.res.topologia3 = this.res.topologiaEI1 + 'S -' + 'F -' + this.res.topologiaJP1;
                         this.res.topologia4 = this.res.topologiaEI1 + 'N -' + 'F -' + this.res.topologiaJP1;
                    }
                    /* Caso 8: que el SEGUNDO (S,N) y el cuarto (J,P) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + this.res.topologiaTF1 + 'J';

                         this.res.topologia3 = this.res.topologiaEI1 + 'S -' + this.res.topologiaTF1 + 'P';
                         this.res.topologia4 = this.res.topologiaEI1 + 'N -' + this.res.topologiaTF1 + 'P';
                    }
                    /* Caso 9: que solo el TERCER (T,F) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === false) {
                         this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'F -' + this.res.topologiaJP1;
                    }
                    /* Caso 10: primero (E,I) y tercero (T,F) sean iguales  */
                    if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === true) {
                         /*  ESTE DEBE SER */
                         this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'T -' + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'F -' + 'J';

                         this.res.topologia3 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'T -' + 'P';
                         this.res.topologia4 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'F -' + 'P';
                    }
                    /* Caso 11: solo el ultimo (J,P) es iguale */
                    if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + this.res.topologiaSN1 + this.res.topologiaTF1 + 'P';
                    }
                    /* Caso 12: solo el cuarto es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === true && this.res.par4iguales === false) {
                         this.res.topologia1 = 'E -' + 'S -' + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + 'S -' + 'T -' + this.res.topologiaJP1;

                         this.res.topologia3 = 'E -' + 'S -' + 'F -' + this.res.topologiaJP1;
                         this.res.topologia4 = 'I -' + 'S -' + 'F -' + this.res.topologiaJP1;

                         this.res.topologia5 = 'E -' + 'N -' + 'T -' + this.res.topologiaJP1;
                         this.res.topologia6 = 'I -' + 'N -' + 'T -' + this.res.topologiaJP1;

                         this.res.topologia7 = 'E -' + 'N -' + 'F -' + this.res.topologiaJP1;
                         this.res.topologia8 = 'I -' + 'N -' + 'F -' + this.res.topologiaJP1;
                    }

                    /* Caso 13: solo el tercero es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + 'S -' + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = 'I -' + 'S -' + this.res.topologiaTF1 + 'J';

                         this.res.topologia3 = 'E -' + 'S -' + this.res.topologiaTF1 + 'P';
                         this.res.topologia4 = 'I -' + 'S -' + this.res.topologiaTF1 + 'P';

                         this.res.topologia5 = 'E -' + 'N -' + this.res.topologiaTF1 + 'J';
                         this.res.topologia6 = 'I -' + 'N -' + this.res.topologiaTF1 + 'J';

                         this.res.topologia7 = 'E -' + 'N -' + this.res.topologiaTF1 + 'P';
                         this.res.topologia8 = 'I -' + 'N -' + this.res.topologiaTF1 + 'P';
                    }

                    /* Caso 14: solo el segundo es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + 'T -' + 'J';
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + 'T -' + 'J';

                         this.res.topologia3 = 'E -' + this.res.topologiaSN1 + 'T -' + 'P';
                         this.res.topologia4 = 'I -' + this.res.topologiaSN1 + 'T -' + 'P';

                         this.res.topologia5 = 'E -' + this.res.topologiaSN1 + 'F -' + 'J';
                         this.res.topologia6 = 'I -' + this.res.topologiaSN1 + 'F -' + 'J';

                         this.res.topologia7 = 'E -' + this.res.topologiaSN1 + 'F -' + 'P';
                         this.res.topologia8 = 'I -' + this.res.topologiaSN1 + 'F -' + 'P';
                    }

                    /* Caso 15: solo el primero es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === true) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + 'T -' + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + 'T -' + 'J';

                         this.res.topologia3 = this.res.topologiaEI1 + 'S -' + 'T -' + 'P';
                         this.res.topologia4 = this.res.topologiaEI1 + 'N -' + 'T -' + 'P';

                         this.res.topologia5 = this.res.topologiaEI1 + 'S -' + 'F -' + 'J';
                         this.res.topologia6 = this.res.topologiaEI1 + 'N -' + 'F -' + 'J';

                         this.res.topologia7 = this.res.topologiaEI1 + 'S -' + 'F -' + 'P';
                         this.res.topologia8 = this.res.topologiaEI1 + 'N -' + 'F -' + 'P';
                    }

                    /* Caso 16: solo el primero es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === true && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + 'S -' + 'T -' + 'J';
                         this.res.topologia2 = 'E -' + 'S -' + 'T -' + 'P';
                         this.res.topologia3 = 'E -' + 'S -' + 'F -' + 'J';
                         this.res.topologia4 = 'E -' + 'S -' + 'F -' + 'P';

                         this.res.topologia5 = 'E -' + 'N -' + 'T -' + 'J';
                         this.res.topologia6 = 'E -' + 'N -' + 'T -' + 'P';

                         this.res.topologia7 = 'E -' + 'S -' + 'F -' + 'J';
                         this.res.topologia8 = 'E -' + 'N -' + 'F -' + 'J';

                         this.res.topologia9 = 'I -' + 'S -' + 'T -' + 'J';
                         this.res.topologia10 = 'I -' + 'S -' + 'T -' + 'P';
                         this.res.topologia11 = 'I -' + 'S -' + 'F -' + 'J';
                         this.res.topologia12 = 'I -' + 'S -' + 'F -' + 'P';

                         this.res.topologia13 = 'I -' + 'N -' + 'T -' + 'J';
                         this.res.topologia14 = 'I -' + 'N -' + 'T -' + 'P';

                         this.res.topologia15 = 'I -' + 'S -' + 'F -' + 'J';
                         this.res.topologia16 = 'I -' + 'N -' + 'F -' + 'J';
                    }

               }
               this.res.topologia = "CASO ESPECIAL: Por lo menos un par tiene valores diferentes.";

               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 136, "SECCION DE TOPOLOGIA " + this.res.topologia);
               doc.line(10, 138, 206, 138);
               doc.text(10, 142, " ( " + this.res.par1iguales + " , " + this.res.par2iguales + " , " + this.res.par3iguales + " , " + this.res.par4iguales + " ) ");
               doc.text(10, 146, "* " + this.res.topologia1);
               doc.text(10, 150, "* " + this.res.topologia2);
               doc.text(10, 154, "* " + this.res.topologia3);
               doc.text(10, 158, "* " + this.res.topologia4);
               doc.text(10, 162, "* " + this.res.topologia5);
               doc.text(10, 166, "* " + this.res.topologia6);
               doc.text(10, 170, "* " + this.res.topologia7);
               doc.text(10, 174, "* " + this.res.topologia8);
               doc.text(10, 178, "* " + this.res.topologia9);
               doc.text(10, 182, "* " + this.res.topologia10);
               doc.text(10, 186, "* " + this.res.topologia11);
               doc.text(10, 190, "* " + this.res.topologia12);
               doc.text(10, 194, "* " + this.res.topologia13);
               doc.text(10, 198, "* " + this.res.topologia14);
               doc.text(10, 202, "* " + this.res.topologia15);
               doc.text(10, 206, "* " + this.res.topologia16);
          },
          losresultados(doc) {

               /* Columnas E & I */
               this.res.E = 0; this.res.I = 0;
               if (this.eval_tipolo.pg001 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg008 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg015 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg022 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg029 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg036 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg043 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg050 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg057 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg064 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }

               /* Columnas intermedias entre (E - I) y (*S - N) 
                    ( a1= ncol11, b2= ncol12 ) */
               this.res.a1 = 0; this.res.b2 = 0; // 10 preguntas 
               if (this.eval_tipolo.pg002 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg009 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg016 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg023 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg030 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg037 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg044 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg051 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg058 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg065 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }

               /* Columnas T & F 
                   a3= ncol3, b4= ncol4  */
               this.res.a3 = 0; this.res.b4 = 0; // 10 preguntas
               if (this.eval_tipolo.pg003 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg010 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg017 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg024 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg031 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg038 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg045 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg052 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg059 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg066 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }

               /* Columnas intermedias entre (S - N) y (*T - F) 
                    a5= ncol5, b6= ncol6 */
               this.res.a5 = 0; this.res.b6 = 0; // 10 preguntas
               if (this.eval_tipolo.pg004 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg011 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg018 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg025 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg032 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg039 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg046 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg053 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg060 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg067 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }

               /* Columnas T & F 
                    a7= ncol7, b8= ncol8 */
               this.res.a7 = 0; this.res.b8 = 0; // 10 preguntas
               if (this.eval_tipolo.pg005 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg012 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg019 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg026 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg033 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg040 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg047 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg054 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg061 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg068 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }

               /* Columnas intermedias entre (T - F) y (*J - P) 
                    a9= ncol9, b10= ncol10 */
               this.res.a9 = 0; this.res.b10 = 0; // 10 preguntas !
               if (this.eval_tipolo.pg006 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg013 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg020 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg027 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg034 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg041 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg048 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg055 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg062 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg069 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }

               /* Columnas intermedias entre (T - F) y (*J - P) 
                    a11= ncol11, b12= ncol12 */
               this.res.a11 = 0; this.res.b12 = 0; // 10 preguntas
               if (this.eval_tipolo.pg007 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg014 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg021 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg028 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg035 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg042 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg049 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg056 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg063 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg070 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }


               // $scope.ncolS = $scope.ncol1 + $scope.ncol3;
               // $scope.ncolN = $scope.ncol2 + $scope.ncol4;
               // let S = 0; let N = 0; 
               this.res.S = 0; this.res.N = 0; // 10 preguntas
               this.res.S = this.res.a1 + this.res.a3;
               this.res.N = this.res.b2 + this.res.b4;

               // $scope.ncolT = $scope.ncol5 + $scope.ncol7;
               // $scope.ncolF = $scope.ncol6 + $scope.ncol8;
               // let T = 0; let F = 0; 
               this.res.T = 0; this.res.F = 0; // 10 preguntas
               this.res.T = this.res.a5 + this.res.a7;
               this.res.F = this.res.b6 + this.res.b8;

               // $scope.ncolJ = $scope.ncol9 + $scope.ncol11;
               // $scope.ncolP = $scope.ncol10 + $scope.ncol12;
               // let J = 0; let P = 0; 
               this.res.J = 0; this.res.P = 0; // 10 preguntas
               this.res.J = this.res.a9 + this.res.a11;
               this.res.P = this.res.b10 + this.res.b12;


               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 70, "SECCION DE RESULTADOS ")
               doc.line(10, 72, 206, 72);
               doc.text(10, 76, "a1 ( " + this.res.a1 + " , " + this.res.b2 + " ) b2");
               doc.text(10, 81, "a5 ( " + this.res.a5 + " , " + this.res.b6 + " ) b6");
               doc.text(10, 86, "a9 ( " + this.res.a9 + " , " + this.res.b10 + " ) b10");
               doc.text(10, 90, "");
               doc.text(10, 94, "a3 ( " + this.res.a3 + " , " + this.res.b4 + " ) b4");
               doc.text(10, 99, "a7 ( " + this.res.a7 + " , " + this.res.b8 + " ) b8");
               doc.text(10, 104, "a11 ( " + this.res.a11 + " , " + this.res.b12 + " ) b12");
               doc.text(10, 108, "");
               doc.text(10, 113, "E  ( " + this.res.E + " , " + this.res.I + " ) I");
               doc.text(10, 118, "S  ( " + this.res.S + " , " + this.res.N + " ) N");
               doc.text(10, 123, "T  ( " + this.res.T + " , " + this.res.F + " ) F");
               doc.text(10, 128, "J  ( " + this.res.J + " , " + this.res.P + " ) P");
          },
          respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 206, 42);
               doc.text(10, 45, this.eval_tipolo.pg001 === "1" ? "| 01= (a)" : "| 01= (b)");
               doc.text(23, 45, this.eval_tipolo.pg002 === "1" ? "| 02= (a)" : "| 02= (b)");
               doc.text(36, 45, this.eval_tipolo.pg003 === "1" ? "| 03= (a)" : "| 03= (b)");
               doc.text(49, 45, this.eval_tipolo.pg004 === "1" ? "| 04= (a)" : "| 04= (b)");
               doc.text(62, 45, this.eval_tipolo.pg005 === "1" ? "| 05= (a)" : "| 05= (b)");
               doc.text(75, 45, this.eval_tipolo.pg006 === "1" ? "| 06= (a)" : "| 06= (b)");
               doc.text(88, 45, this.eval_tipolo.pg007 === "1" ? "| 07= (a)" : "| 07= (b)");
               doc.text(101, 45, this.eval_tipolo.pg008 === "1" ? "| 08= (a)" : "| 08= (b)");
               doc.text(114, 45, this.eval_tipolo.pg009 === "1" ? "| 09= (a)" : "| 09= (b)");
               doc.text(127, 45, this.eval_tipolo.pg010 === "1" ? "| 10= (a)" : "| 10= (b)");
               doc.text(140, 45, this.eval_tipolo.pg011 === "1" ? "| 11= (a)" : "| 11= (b)");
               doc.text(153, 45, this.eval_tipolo.pg012 === "1" ? "| 12= (a)" : "| 12= (b)");
               doc.text(166, 45, this.eval_tipolo.pg013 === "1" ? "| 13= (a)" : "| 13= (b)");
               doc.text(179, 45, this.eval_tipolo.pg014 === "1" ? "| 14= (a)" : "| 14= (b)");
               doc.text(192, 45, this.eval_tipolo.pg015 === "1" ? "| 15= (a)" : "| 15= (b) |");
               doc.line(10, 46, 206, 46);
               doc.text(10, 49, this.eval_tipolo.pg016 === "1" ? "| 16= (a)" : "| 16= (b)");
               doc.text(23, 49, this.eval_tipolo.pg017 === "1" ? "| 17= (a)" : "| 17= (b)");
               doc.text(36, 49, this.eval_tipolo.pg018 === "1" ? "| 18= (a)" : "| 18= (b)");
               doc.text(49, 49, this.eval_tipolo.pg019 === "1" ? "| 19= (a)" : "| 19= (b)");
               doc.text(62, 49, this.eval_tipolo.pg020 === "1" ? "| 20= (a)" : "| 20= (b)");
               doc.text(75, 49, this.eval_tipolo.pg021 === "1" ? "| 21= (a)" : "| 21= (b)");
               doc.text(88, 49, this.eval_tipolo.pg022 === "1" ? "| 22= (a)" : "| 22= (b)");
               doc.text(101, 49, this.eval_tipolo.pg023 === "1" ? "| 23= (a)" : "| 23= (b)");
               doc.text(114, 49, this.eval_tipolo.pg024 === "1" ? "| 24= (a)" : "| 24= (b)");
               doc.text(127, 49, this.eval_tipolo.pg025 === "1" ? "| 25= (a)" : "| 25= (b)");
               doc.text(140, 49, this.eval_tipolo.pg026 === "1" ? "| 26= (a)" : "| 26= (b)");
               doc.text(153, 49, this.eval_tipolo.pg027 === "1" ? "| 27= (a)" : "| 27= (b)");
               doc.text(166, 49, this.eval_tipolo.pg028 === "1" ? "| 28= (a)" : "| 28= (b)");
               doc.text(179, 49, this.eval_tipolo.pg029 === "1" ? "| 29= (a)" : "| 29= (b)");
               doc.text(192, 49, this.eval_tipolo.pg030 === "1" ? "| 30= (a)" : "| 30= (b) |");
               doc.line(10, 50, 206, 50);
               doc.text(10, 53, this.eval_tipolo.pg031 === "1" ? "| 31= (a)" : "| 31= (b)");
               doc.text(23, 53, this.eval_tipolo.pg032 === "1" ? "| 32= (a)" : "| 32= (b)");
               doc.text(36, 53, this.eval_tipolo.pg033 === "1" ? "| 33= (a)" : "| 33= (b)");
               doc.text(49, 53, this.eval_tipolo.pg034 === "1" ? "| 34= (a)" : "| 34= (b)");
               doc.text(62, 53, this.eval_tipolo.pg035 === "1" ? "| 35= (a)" : "| 35= (b)");
               doc.text(75, 53, this.eval_tipolo.pg036 === "1" ? "| 36= (a)" : "| 36= (b)");
               doc.text(88, 53, this.eval_tipolo.pg037 === "1" ? "| 37= (a)" : "| 37= (b)");
               doc.text(101, 53, this.eval_tipolo.pg038 === "1" ? "| 38= (a)" : "| 38= (b)");
               doc.text(114, 53, this.eval_tipolo.pg039 === "1" ? "| 39= (a)" : "| 39= (b)");
               doc.text(127, 53, this.eval_tipolo.pg040 === "1" ? "| 40= (a)" : "| 40= (b)");
               doc.text(140, 53, this.eval_tipolo.pg041 === "1" ? "| 41= (a)" : "| 41= (b)");
               doc.text(153, 53, this.eval_tipolo.pg042 === "1" ? "| 42= (a)" : "| 42= (b)");
               doc.text(166, 53, this.eval_tipolo.pg043 === "1" ? "| 43= (a)" : "| 43= (b)");
               doc.text(179, 53, this.eval_tipolo.pg044 === "1" ? "| 44= (a)" : "| 44= (b)");
               doc.text(192, 53, this.eval_tipolo.pg045 === "1" ? "| 45= (a)" : "| 45= (b) |");
               doc.line(10, 54, 206, 54);
               doc.text(10, 57, this.eval_tipolo.pg046 === "1" ? "| 46= (a)" : "| 46= (b)");
               doc.text(23, 57, this.eval_tipolo.pg047 === "1" ? "| 47= (a)" : "| 47= (b)");
               doc.text(36, 57, this.eval_tipolo.pg048 === "1" ? "| 48= (a)" : "| 48= (b)");
               doc.text(49, 57, this.eval_tipolo.pg049 === "1" ? "| 49= (a)" : "| 49= (b)");
               doc.text(62, 57, this.eval_tipolo.pg050 === "1" ? "| 50= (a)" : "| 50= (b)");
               doc.text(75, 57, this.eval_tipolo.pg051 === "1" ? "| 51= (a)" : "| 51= (b)");
               doc.text(88, 57, this.eval_tipolo.pg052 === "1" ? "| 52= (a)" : "| 52= (b)");
               doc.text(101, 57, this.eval_tipolo.pg053 === "1" ? "| 53= (a)" : "| 53= (b)");
               doc.text(114, 57, this.eval_tipolo.pg054 === "1" ? "| 54= (a)" : "| 54= (b)");
               doc.text(127, 57, this.eval_tipolo.pg055 === "1" ? "| 55= (a)" : "| 55= (b)");
               doc.text(140, 57, this.eval_tipolo.pg056 === "1" ? "| 56= (a)" : "| 56= (b)");
               doc.text(153, 57, this.eval_tipolo.pg057 === "1" ? "| 57= (a)" : "| 57= (b)");
               doc.text(166, 57, this.eval_tipolo.pg058 === "1" ? "| 58= (a)" : "| 58= (b)");
               doc.text(179, 57, this.eval_tipolo.pg059 === "1" ? "| 59= (a)" : "| 59= (b)");
               doc.text(192, 57, this.eval_tipolo.pg060 === "1" ? "| 60= (a)" : "| 60= (b) |");
               doc.line(10, 58, 206, 58);
               doc.text(10, 61, this.eval_tipolo.pg061 === "1" ? "| 61= (a)" : "| 61= (b)");
               doc.text(23, 61, this.eval_tipolo.pg062 === "1" ? "| 62= (a)" : "| 62= (b)");
               doc.text(36, 61, this.eval_tipolo.pg063 === "1" ? "| 63= (a)" : "| 63= (b)");
               doc.text(49, 61, this.eval_tipolo.pg064 === "1" ? "| 64= (a)" : "| 64= (b)");
               doc.text(62, 61, this.eval_tipolo.pg065 === "1" ? "| 65= (a)" : "| 65= (b)");
               doc.text(75, 61, this.eval_tipolo.pg066 === "1" ? "| 66= (a)" : "| 66= (b)");
               doc.text(88, 61, this.eval_tipolo.pg067 === "1" ? "| 67= (a)" : "| 67= (b)");
               doc.text(101, 61, this.eval_tipolo.pg068 === "1" ? "| 68= (a)" : "| 68= (b)");
               doc.text(114, 61, this.eval_tipolo.pg069 === "1" ? "| 69= (a)" : "| 69= (b)");
               doc.text(127, 61, this.eval_tipolo.pg070 === "1" ? "| 70= (a)" : "| 70= (b) |");
               doc.line(10, 62, 141, 62);

          },
          ejeSinContestar: function () {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg002 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg003 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }

               return this.ejeSinResponder;
          },
          sinContestar: function () {

               this.pregSinContestar = 0;

               if (this.eval_tipolo.pg001 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg002 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg003 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg004 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg005 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg006 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg007 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg008 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg009 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg010 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg011 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg012 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg013 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg014 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg015 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg016 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg017 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg018 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg019 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg020 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg021 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg022 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg023 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }

               if (this.eval_tipolo.pg024 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg025 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg026 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg027 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg028 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg029 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg030 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg031 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg032 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg033 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg034 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg035 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg036 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg037 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg038 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg039 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg040 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg041 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg042 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg043 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg044 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg045 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg046 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }

               if (this.eval_tipolo.pg047 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg048 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg049 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg050 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg051 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg052 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg053 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg054 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg055 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg056 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg057 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg058 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg059 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg060 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg061 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg062 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg063 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg064 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg065 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg066 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg067 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg068 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg069 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_tipolo.pg070 === 0) { this.pregSinContestar = this.pregSinContestar + 1; }

               return this.pregSinContestar;
          },
          dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof (date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0]
          },
          cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(),
                    d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               let localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0,
               };

               this.eval_tipolo    = store.state.st_ev01;        // Crea el nodo para todos los campos.
               this.res            = store.state.st_rs01;
               console.log("res ? ", this.res);

               this.eval_tipolo.nombre = store.state.st_nusuario;    // Nombre del usuario que hará la evaluación
               this.eval_tipolo.empresa = store.state.st_empresa;     // Nombre de la empresa a la cual pertenece el usuario
               this.eval_tipolo.depto=  store.state.st_depto;
               this.eval_tipolo.sexo=   store.state.st_sexo;

               this.instrucciones = this.eval_tipolo.nombre.toUpperCase() + " haga click aqui para para leer las instrucciones para responder la evaluación de TIPOLOGIA DE LA PERSONALIDAD."

               this.eval_fecha = new Date();                 // Fecha del Día
          },
          empezarEvaluacion() {

               this.eval_tipolo.empezo = this.cargaHora();
               this.inicioeval = true;
               // this.$refs.temporalito.focus()
               // this.$refs.pg1.focus()
               // this.$refs.pg1.$el.focus()

          },
          /** .................... VALIDACIONES  .................... */
          validarValor(valor) {
               let lvalor = valor;
               if (valor < 1 || valor > 2) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0,
               };

               this.eval_tipolo = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                    pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
                    pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, pg049: 0, pg050: 0,
                    pg051: 0, pg052: 0, pg053: 0, pg054: 0, pg055: 0, pg056: 0, pg057: 0, pg058: 0, pg059: 0, pg060: 0,
                    pg061: 0, pg062: 0, pg063: 0, pg064: 0, pg065: 0, pg066: 0, pg067: 0, pg068: 0, pg069: 0, pg070: 0,
               }

               /* Variables para un nuevo caso */
               store.state.eval_tipolo = this.eval_tipolo;
          },
          //** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          //* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion() {

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ")
                    return
               }

               this.finalizoeval = true;
               this.eval_tipolo.termino = this.cargaHora();

               this.eval_fecha = new Date();

               let ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               let lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               let lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();

               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ",this.eval_fecha);
               console.log("** formato  ingreso ? ",lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de TIPOLOGIA DE PERSONALIDAD para " + this.eval_tipolo.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvalTipolo = store.state.st_dbEvalTipolo;
                    dbEvalTipolo.push({

                         empresa: this.eval_tipolo.empresa, nombre: this.eval_tipolo.nombre,
                         empezo: this.eval_tipolo.empezo, termino: this.eval_tipolo.termino,
                         fecha: lingreso, sexo: this.eval_tipolo.sexo, depto: this.eval_tipolo.depto,
                         pg001: this.eval_tipolo.pg001, pg002: this.eval_tipolo.pg002, pg003: this.eval_tipolo.pg003, pg004: this.eval_tipolo.pg004, pg005: this.eval_tipolo.pg005,
                         pg006: this.eval_tipolo.pg006, pg007: this.eval_tipolo.pg007, pg008: this.eval_tipolo.pg008, pg009: this.eval_tipolo.pg009, pg010: this.eval_tipolo.pg010,
                         pg011: this.eval_tipolo.pg011, pg012: this.eval_tipolo.pg012, pg013: this.eval_tipolo.pg013, pg014: this.eval_tipolo.pg014, pg015: this.eval_tipolo.pg015,
                         pg016: this.eval_tipolo.pg016, pg017: this.eval_tipolo.pg017, pg018: this.eval_tipolo.pg018, pg019: this.eval_tipolo.pg019, pg020: this.eval_tipolo.pg020,
                         pg021: this.eval_tipolo.pg021, pg022: this.eval_tipolo.pg022, pg023: this.eval_tipolo.pg023, pg024: this.eval_tipolo.pg024, pg025: this.eval_tipolo.pg025,
                         pg026: this.eval_tipolo.pg026, pg027: this.eval_tipolo.pg027, pg028: this.eval_tipolo.pg028, pg029: this.eval_tipolo.pg029, pg030: this.eval_tipolo.pg030,
                         pg031: this.eval_tipolo.pg031, pg032: this.eval_tipolo.pg032, pg033: this.eval_tipolo.pg033, pg034: this.eval_tipolo.pg034, pg035: this.eval_tipolo.pg035,
                         pg036: this.eval_tipolo.pg036, pg037: this.eval_tipolo.pg037, pg038: this.eval_tipolo.pg038, pg039: this.eval_tipolo.pg039, pg040: this.eval_tipolo.pg040,
                         pg041: this.eval_tipolo.pg041, pg042: this.eval_tipolo.pg042, pg043: this.eval_tipolo.pg043, pg044: this.eval_tipolo.pg044, pg045: this.eval_tipolo.pg045,
                         pg046: this.eval_tipolo.pg046, pg047: this.eval_tipolo.pg047, pg048: this.eval_tipolo.pg048, pg049: this.eval_tipolo.pg049, pg050: this.eval_tipolo.pg050,
                         pg051: this.eval_tipolo.pg051, pg052: this.eval_tipolo.pg052, pg053: this.eval_tipolo.pg053, pg054: this.eval_tipolo.pg054, pg055: this.eval_tipolo.pg055,
                         pg056: this.eval_tipolo.pg056, pg057: this.eval_tipolo.pg057, pg058: this.eval_tipolo.pg058, pg059: this.eval_tipolo.pg059, pg060: this.eval_tipolo.pg060,
                         pg061: this.eval_tipolo.pg061, pg062: this.eval_tipolo.pg062, pg063: this.eval_tipolo.pg063, pg064: this.eval_tipolo.pg064, pg065: this.eval_tipolo.pg065,
                         pg066: this.eval_tipolo.pg066, pg067: this.eval_tipolo.pg067, pg068: this.eval_tipolo.pg068, pg069: this.eval_tipolo.pg069, pg070: this.eval_tipolo.pg070,
                    }).then((data) => {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         this.limpiarEvaluacion();

                         var laClave = data.key;
                         this.grabado = true;
                         this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de TIPOLOGIA DE PERSONALIDAD guardado con éxito.")
                    });
               } // if (confirma)
          },

          //? =================================================================================
          enfoqueG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2: //* Estoy en el 1 y quiero irme al 2
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());

                         this.activott1="!active";
                         this.activott2="active";

                         this.vertt1=false;
                         this.vertt2=true;
                         break;
                    case 3: //* Estoy en el 2 y quiero irme al 3
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());
                         this.activott2="!active";
                         this.activott3="active";

                         this.vertt2=false;                         
                         this.vertt3=true;
                         break;
                    case 0: //* Estoy en el 3 y quiero irme al 2 o al 1
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott3="!active";
                         this.activott1="active";

                         this.vertt3=false;
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
          nadaG1(pestana){
               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());

                         this.activott1="active";
                         this.activott2="!active";
                         this.activott3="!active";

                         this.vertt1=true;
                         this.vertt2=false;
                         this.vertt3=false;

                         break;
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());
                         this.activott1="!active";
                         this.activott2="active";
                         this.activott3="!active";

                         this.vertt1=false;
                         this.vertt2=true;
                         this.vertt3=false;

                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=true;

                         break;
                    default:                         
                    // code block
               } //* switch
          },
          enfoqueRG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2: //* Estoy en 3 regreso a 2
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());

                         this.activott3="!active";
                         this.activott2="active";

                         this.vertt3=false;
                         this.vertt2=true;
                         break;
                    case 1:   //* Estoy en 2 regreso a 1
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott2="!active";
                         this.activott1="active";

                         this.vertt2=false;                         
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },          
     }, // methods
} // export



// WEBPACK FOOTER //
// ./src/components/ev01_tipologia.js